import addError from '../../../utils/error.jsx';

export function request(id, marketId, eventId) {
    return {
        type: 'SELECTIONS_SETTLE_REQUEST',
        marketId,
        eventId,
        id
    };
}

export function error(id, errors) {
    addError(errors);

    return {
        type: 'SELECTIONS_SETTLE_ERROR',
        errors,
        id
    };
}

export function finish(id, selection) {
    return {
        type: 'SELECTIONS_SETTLE_FINISH',
        selection,
        id
    };
}
